import React from "react";

const ErrorPage = () => {
  return (
    <div className="container">
      <h1>404 page</h1>
    </div>
  );
};

export default ErrorPage;